import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { conversationId: Number }
  static targets = ["dialog"]

  open(event) {
    event?.preventDefault?.()
    const dlg = this.dialogTarget
    if (typeof dlg.showModal === "function") dlg.showModal()
    else dlg.setAttribute("open", "")
  }

  close() {
    const dlg = this.dialogTarget
    if (typeof dlg.close === "function") dlg.close()
    else dlg.removeAttribute("open")
  }

  // Click outside the dialog content (on the backdrop/margin) closes the dialog.
  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  onClose() {
    // Hook for future (animations, focus restoration).
  }

  async select(event) {
    event.preventDefault?.()
    const btn = event.currentTarget
    const personaId = btn.dataset.personaId
    if (!personaId) return

    btn.setAttribute("aria-busy", "true")
    btn.classList.add("opacity-60", "pointer-events-none")

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(`/conversations/${this.conversationIdValue}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          "Accept": "application/json"
        },
        body: JSON.stringify({ persona_id: personaId })
      })
      if (!response.ok) throw new Error(`${response.status}: ${await response.text()}`)
      // Full reload picks up the new persona everywhere (avatar, system prompt, badge).
      window.location.reload()
    } catch (err) {
      console.error("[persona-switcher] failed:", err)
      btn.removeAttribute("aria-busy")
      btn.classList.remove("opacity-60", "pointer-events-none")
    }
  }
}
